import { h, Fragment } from 'preact';
import clsx from 'clsx';
import IconPlus from "utils/icon/icon-plus.svg";
import IconMinus from "utils/icon/icon-minus.svg";

const Accordion = ({
  title, content, isGeneric = true,
  classes, children, toggleAccordeon, openedIndex, index
}) => (
  <>
    {(title || children) && (
      <>
        <div
          className={clsx(
            classes?.accordion,
            'cursor-pointer flex justify-between items-center',
            openedIndex === index && 'pb-3',
          )}
          onClick={() => toggleAccordeon(index)}
        >
          <p className={classes?.title}>{title}</p>
          <div className="text-white drop-shadow-md">
            {openedIndex === index ? <IconMinus /> : <IconPlus />}
          </div>
        </div>
        <div className={clsx(classes?.content, openedIndex === index && '!max-h-[1000px]')}>
          {children && <div className="mb-3">{children}</div>}
          {!children && isGeneric && content && (
            <div className="[&_*]:body-xs md:[&_*]:body [&_*]:body [&_*]:text-grey-5C [&_p]:pb-4 -mt-[4px] md:mt-0 [&_strong]:label-12 [&_strong]:tracking-[2px] [&_strong]:uppercase body-xs md:body [&_em]:bg-white [&_em]:rounded [&_em]:px-1 [&_em]:py-0.5 [&_em]:font-semibold [&_em]:not-italic [&_em]:tracking-[2px]"
              dangerouslySetInnerHTML={{ __html: content }}></div>
          )}
          {!children && content && !isGeneric && (
            <div className="[&_*]:body-xs md:[&_*]:body [&_*]:body [&_*]:text-grey-5C -mt-[4px] md:mt-0 [&_p]:pb-4 [&_strong]:label-12 [&_strong]:tracking-[2px] [&_strong]:uppercase body-xs md:body [&_em]:bg-white [&_em]:rounded [&_em]:px-1 [&_em]:py-0.5 [&_em]:font-semibold [&_em]:not-italic [&_em]:tracking-[2px]"
              dangerouslySetInnerHTML={{ __html: content }}></div>
          )}
        </div>
      </>
    )}
  </>
);

export default Accordion;
